import _ from '/home/ps/root'
import PropTypes from 'prop-types'
import action from '../action'
import { bindActionCreators } from 'redux'
// import { noun } from '../global'

const {array, bool, func, number, object, string, symbol, node, element, elementType, instanceOf, oneOf, oneOfType, arrayOf, objectOf, shape, exact, any} = PropTypes
const history = oneOf(['replace', 'pop', 'push']).isRequred

// export const masterPropType = shape({
//   [_.DIRECTION]: string.isRequred,
//   [_.ID_USER]: number.isRequred,
//   [_.LANGUAGE]: oneOf(_.LANG).isRequred,
//   slide: shape({
//     [_.ID]: oneOf([
//       _.ID_MASTER_LOGO,
//       _.ID_MASTER_BOARD_NOTICE,
//       _.ID_MASTER_BOARD_CHAT,
//       _.ID_MASTER_FOOTER,
//     ]).isRequred,
//     [_.VERB]: oneOf([_.HIDE, _.SHOW]).isRequred,
//   }).isRequred,
//   [_.APP]: shape({
//     [_.ID]: string.isRequred,
//   }).isRequred,
//   master: shape({
//     [_.ID]: string.isRequred,
//     [_.LOCALE]: string.isRequred,
//     [_.DATA]: object.isRequred,
//   }).isRequred,
//   [_.Q]: shape({
//     [_.ID]: string.isRequred,
//     [_.LOCALE]: string.isRequred,
//     [_.DATA]: object.isRequred,
//   }).isRequred,
//   [_.V]: shape({
//     [_.ID]: string.isRequred,
//     [_.LOCALE]: string.isRequred,
//     [_.DATA]: object.isRequred,
//   }).isRequred,
//   [_.CONTROL]: shape({
//     [_.ID]: string.isRequred,
//     [_.LOCALE]: string.isRequred,
//     [_.DATA]: object.isRequred,
//   }).isRequred,
//   [_.VIEW]: shape({
//     [_.ID]: string.isRequred,
//   }).isRequred,
//   [_.MODEL]: shape({
//     [_.ID]: string.isRequred,
//   }).isRequred,
//   // [_.FIELD]: shape({
//   //   [_.ID]: string.isRequred,
//   //   [_.LOCALE]: string.isRequred,
//   //   [_.DATA]: object.isRequred,
//   // }).isRequred,
//   // [_.ROW]: shape({
//   //   [_.ID]: string.isRequred,
//   //   [_.LOCALE]: string.isRequred,
//   //   [_.DATA]: object.isRequred,
//   // }).isRequred,
//   // [_.TABLE]: shape({
//   //   [_.ID]: string.isRequred,
//   //   [_.LOCALE]: string.isRequred,
//   //   [_.DATA]: object.isRequred,
//   // }).isRequred,
//   screen : object.isRequred,
//   [_.ACTION]: shape({
//     slide: func.isRequred,
//     // view
//     // [_.APP]: func.isRequred,
//     // static
//     master: func.isRequred,
//     [_.Q]: func.isRequred,
//     [_.V]: func.isRequred,
//     // CONTROL
//     [_.TASK]: func.isRequred,
//     [_.PROCESS]: func.isRequred,
//     [_.JOB]: func.isRequred,
//     [_.BATCH]: func.isRequred,
//     // model
//     // [_.FIELD]: func.isRequred,
//     [_.ROW]: func.isRequred,
//     // [_.TABLE]: func.isRequred,
//     // ui
//     screen : func.isRequred,
//   }).isRequred,
// })

export const masterStateToProp = state => { //, ownProp) {
  return state.master

  const m = state.master
  return {
    p: m.p,
    screen: m.screen,
    // go:       state.master.go,
    dir: m.dir,
    lang: m.lang,
    slide: m.slide,
    // fetch:    state.master.fetch,
    init: m.init,
    select: m.select,
    // login:   state.master.login,
    // mount:    state.master.mount,
    // id:   state.master.id,
    find: m.find,
    new: m.new,
    online: m.online,
    user: m.user,
    q: m.q,
    // vendor:   state.master.vendor,
    // customer: state.master.customer,
    // employee: state.master.employee,
    // shipper:  state.master.shipper,
    io: m.io,
    // connect: state.master.connect,

    // p: state.master.p,
    // screen: state.master.screen,
    // // go:       state.master.go,
    // dir: state.master.dir,
    // lang: state.master.lang,
    // slide: state.master.slide,
    // // fetch:    state.master.fetch,
    // init: state.master.init,
    // select: state.master.select,
    // // login:   state.master.login,
    // // mount:    state.master.mount,
    // // id:   state.master.id,
    // find: state.master.find,
    // new: state.master.new,
    // online: state.master.online,
    // user: state.master.user,
    // q: state.master.q,
    // // vendor:   state.master.vendor,
    // // customer: state.master.customer,
    // // employee: state.master.employee,
    // // shipper:  state.master.shipper,
    // io: state.master.io,
    // // connect: state.master.connect,
  }
}
// export const masterStateToProp = state => { //, ownProp) {
//   return state.master
// }
export const masterDispatchToProp = dispatch => ({action: bindActionCreators(action, dispatch)})
// export function masterDispatchToProp (dispatch) {
//   return {action: bindActionCreators(action, dispatch)}
// }
